export const GET_MULTI_DASHBOARD_ANALYTICS = "GET_MULTI_DASHBOARD_ANALYTICS"
export const GET_ALL_ALERTS = "GET_ALL_ALERTS"
export const GET_MULTI_ALERTS = "GET_MULTI_ALERTS"
export const GET_ACCESS_PRIVILEGE = "GET_ACCESS_PRIVILEGE"
export const GET_USER_ROLES = "GET_USER_ROLES"
export const GET_HIGH_RISK_DEVICES = "GET_HIGH_RISK_DEVICES"
export const GET_ANOMALIES = "GET_ANOMALIES"
export const GET_THREATS = "GET_THREATS"

